module.exports = __webpack_public_path__ + "static/heroVid-e86d2578da92026e5b1379a85bdda998.webm";